export default __webpack_public_path__ + "static/media/62.8c1dbf1c.jpg";